export const createError = ({ type, message }) => dispatch =>
  dispatch({ type: type + "_ERROR", payload: message });
